// Approval statuses are used in welcome page.
export const APPROVED = 'Approved'
export const REJECTED = 'Rejected'
export const PENDING = 'Pending'
